<template>
  <div>
    <slot>
      <component
        ref="data-input"
        :is="formatedDataType"
        v-model="computedValue"
        v-bind="{ ...$props, ...$attrs, ...staticProps }"
        v-on="getListeners($listeners)"
        :items="computedItems"
        :descriptors="dataType"
      >
        <template v-for="(value, key) in $scopedSlots" #[key]="scope">
          <slot :name="key" v-bind="scope" />
        </template>
      </component>
    </slot>
  </div>
</template>

<script>
import { camelCase, cloneDeep } from 'lodash';
import { capitalize } from '@/assets/js/utility';

const components = {};
const requireComponent = require.context('@/components/shared/inputs', false, /DataInput\w+\.(vue|js)$/);
requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName);
  const componentName = capitalize(
    camelCase(
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  );
  components[componentName] = componentConfig.default;
});

export default {
  name: 'DataInput',
  components,
  inheritAttrs: false,
  props: {
    value: {
      default: null,
    },
    dataType: {
      type: Object,
      required: false,
    },
    autoConvertSelect: {
      type: Boolean,
      default: true,
    },
    disabledSorting: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    staticProps: {
      outlined: true,
      ripple: false,
      dense: true,
    },
  }),
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(nV) {
        this.$emit('input', nV);
      },
    },
    computedItems() {
      if (!this.$attrs.items) {
        return;
      }
      if (this.disabledSorting) {
        return this.$attrs.items;
      }
      const sortKey = this.$attrs['item-text'] || this.$attrs['itemText'] || 'text';
      return this.$_sortObjectsByAttribute(cloneDeep(this.$attrs.items), sortKey);
    },
    formatedDataType() {
      if (!this.dataType) {
        throw new Error('Prop dataType is required');
      }
      if (this.autoConvertSelect && this.dataType.name === 'select' && this.computedItems?.length > 8) {
        return `DataInputAutocomplete`;
      }
      const capitalizedName = this.$_capitalize(this.dataType.name);
      return `DataInput${capitalizedName}`;
    },
  },
  methods: {
    getListeners(listeners) {
      return this.$_filterObjectKeys(listeners, { notAllowedKeys: 'input' });
    },
  },
};
</script>
